export default ({
  req,
  res,
  route,
  app,
  $axios,
  redirect,
  env
}) => {
  $axios.onRequest((config) => {
    if(config.headers.common && !(config.headers.common||{}).shopster){
      if(process.server){
        config.headers.common.shopster = req.headers.host + route.fullPath.split('-')[0]
      }else{
        config.headers.common.shopster = location.host + route.fullPath.split('-')[0]
      }
    }
  });
}
